import React from 'react';

function ModalCentered({ id, title, children, confirmText, funct }) {
    return (
        <div className="modal" id={id} tabIndex="-1" role="dialog" aria-labelledby={`${id}Label`} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id={`${id}Label`}>{title}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        {
                            confirmText &&
                            <button type="button" className="btn-bgSAP mx-1 my-3" onClick={(e) => funct(e)} >{confirmText}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(ModalCentered)